import { ErrorHandler, Injectable } from '@angular/core'

// To re-enable analytics tracking, restore: import { ErrorHandler, Injectable, Injector, inject } from '@angular/core'
import * as Sentry from '@sentry/angular'

// import { AnalyticsService } from '@flowx/designer/modules/analytics/analytics.service'

/**
 * ErrorHandler that emits an `error_occurred` analytics event (categorized, no PII)
 * and then delegates to the Sentry error handler. AnalyticsService is resolved lazily
 * via the Injector to avoid bootstrap-order issues, and analytics failures are swallowed
 * so they can never interfere with error reporting.
 *
 * NOTE: the `error_occurred` Mixpanel tracking is TEMPORARILY DISABLED to stop
 * overflowing Mixpanel. To restore it, uncomment the imports above, the `#injector`
 * field, the tracking block in `handleError`, and the `#categorize` method below.
 */
@Injectable()
export class AnalyticsErrorHandler implements ErrorHandler {
  // #injector = inject(Injector)
  #sentryHandler = Sentry.createErrorHandler({ showDialog: false })

  handleError(error: unknown): void {
    // Temporarily disabled to stop overflowing Mixpanel with `error_occurred` events.
    // try {
    //   this.#injector
    //     .get(AnalyticsService)
    //     .trackUntyped(
    //       { object: 'error', action: 'occurred' },
    //       { category: this.#categorize(error), name: (error as Error)?.name ?? 'Unknown' }
    //     )
    // } catch {
    //   // never let analytics break error handling
    // }

    this.#sentryHandler.handleError(error)
  }

  // #categorize(error: unknown): string {
  //   const message = (error as Error)?.message ?? String(error)
  //
  //   if (/ChunkLoadError|Loading chunk|dynamically imported module/i.test(message)) {
  //     return 'chunk_load'
  //   }
  //   if (/Network|Http failure|status: 0/i.test(message)) {
  //     return 'network'
  //   }
  //   if (error instanceof TypeError) {
  //     return 'type_error'
  //   }
  //   return 'unknown'
  // }
}
